var map = {
	"./JP.json": "074b",
	"./MX.json": "4a11",
	"./US.json": "5a90",
	"./about-JP.json": "9912",
	"./about-MX.json": "84b4",
	"./about-US.json": "6db7",
	"./errors-JP.json": "1a2a",
	"./errors-MX.json": "487b",
	"./errors-US.json": "9d2c",
	"./terms-JP.json": "15f7",
	"./terms-MX.json": "ad26",
	"./terms-US.json": "1c63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba7e";